import type { ReactNode } from 'react'
import { Sparkles } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import {
  FLOATING_SHAPE_CLASS,
  FLOATING_EDGE_CLASS,
  FLOATING_SURFACE_STYLE,
} from '@renderer/components/floating-surface'

/**
 * Centered progress pill shown while a regeneration is in flight. `children`
 * (an optional trailing control) renders inside the centering wrapper so the
 * pill and control center together as one cluster.
 */
export function BusyPill({ label, children }: { label: string; children?: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-1 items-center justify-center gap-2">
      <div
        className={twMerge(FLOATING_EDGE_CLASS, 'flex h-7 min-w-0 items-center gap-1.5 px-2.5', FLOATING_SHAPE_CLASS)}
        style={FLOATING_SURFACE_STYLE}
      >
        <Sparkles aria-hidden="true" className="text-foreground-secondary size-3.5 animate-pulse" />
        <span className="text-foreground-secondary type-ui-sm truncate font-medium">{label}</span>
      </div>
      {children}
    </div>
  )
}
